







import { Component, Prop, Vue } from 'vue-property-decorator'

/**
 * @component
 * @description 提供了一套常用的图标集合
 */
@Component({
  name: 'SuiIcon'
})
export default class Comp extends Vue {
  static install(vue: any) {
    vue.component((this as any).options.name, Comp)
  }

  /**
  * @prop type
  * @type string
  * @description 样式类型
  */
  @Prop({
    type: String
  })
  type!: string

  /**
  * @prop color
  * @type string
  * @description 颜色
  */
  @Prop({
    type: String
  })
  color!: string

  /**
  * @prop size
  * @type string
  * @description 图标大小
  * @default 16px
  */
  @Prop({
    type: String
  })
  size!: string

  get iconClass() {
    return 'sui-icon-' + this.type.replace(/\s*/g, '')
  }
}
